import { DiscountRecord, discountFromJSON } from "common/records/Discount";
import { RootActions, RootState } from "common/reducers";
import * as discountActions from "common/reducers/discount.actions";
import { receive, reset } from "common/reducers/Utils";
import { Map, Record } from "immutable";

export const DiscountStateRecord = Record({
  byId: Map<number, DiscountRecord>(),
  lastSavedById: Map<number, DiscountRecord>(),
});

export const initialState = DiscountStateRecord();
export type DiscountState = typeof initialState;

const rootKey = "discounts";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.getIn([rootKey])) {
    state = state.setIn([rootKey], initialState);
  }
  switch (action.type) {
    case discountActions.RECEIVE_DISCOUNT:
      const discount = discountFromJSON({ ...action.payload });

      return receive(state, rootKey, discount);

    case discountActions.RECEIVE_DISCOUNTS:
      action.payload.discounts.forEach((discount) => {
        state = reducer(state, discountActions.DiscountActions.receiveDiscount(discount));
      });

      return state;

    case discountActions.REMOVE_DISCOUNT:
      return state.removeIn([rootKey, "byId", action.payload]);

    case discountActions.RESET_DISCOUNT:
      return reset(state, rootKey, action.payload);
    default:
      return state;
  }
};
